// extracted by mini-css-extract-plugin
export default {"scoreContainer":"ScoreBox_scoreContainer__AUP1F","score":"ScoreBox_score__ryBm9"};